import React, { useMemo } from 'react';
import { Message } from 'botframework-directlinejs';
import { mergeClasses } from '@fluentui/react-components';

import { BaseMessage, IBaseMessageProps } from './base-message';

interface IHumanMessageProps extends Omit<IBaseMessageProps, 'isAIMessage'> {
  message: Message;
}

export const HumanMessage: React.FC<IHumanMessageProps> = React.memo((props) => {
  const { message } = props;

  const parsedTextContent = useMemo(
    // Strip entity markers to show only entity names:
    // 1. JSON format: {"entityType":"Campaign","entityId":"X","entityName":"Y"}
    // 2. Legacy format: {Campaign:name} or {AdGroup:name}
    () => (message.text || '')
      .replace(/\{"entityType":"[^"]+","entityId":"[^"]+","entityName":"([^"]+)"\}/g, (_, name) => name.trim())
      .replace(/{(Campaign|AdGroup):([^}]+)}/g, (_, _type, name) => name.trim()),
    [message.text]
  );

  const pluginName = (message.value as any)?.PluginContext?.Name;
  if (pluginName === 'AccountFluctuation' || pluginName === 'CampaignFluctuation') {
    // do not show the automated message to trigger fluctuations
    return null;
  }

  return (
    <BaseMessage
      {...props}
      className={mergeClasses(props.className, 'human-message')}
    >
      <span className="content">{parsedTextContent}</span>
    </BaseMessage>
  );
});
